

import { NgModule } from '@angular/core';
import { NzSpinModule } from 'ng-zorro-antd/spin'
import { MmOverlaySpinningComponent } from './components/overlay-spinning';
import { MmGlobalSpinningDirective } from './global-spinning.directive';

@NgModule({
    imports: [NzSpinModule],
    exports: [NzSpinModule, MmGlobalSpinningDirective],
    declarations: [MmOverlaySpinningComponent, MmGlobalSpinningDirective],
    providers: [],
})
export class MmSpinModule { }
